export default function ({ store }) {
  if (Object.keys(store.state.config.default_options).length === 0) {
    store.dispatch('config/getDefaultOptions')
  }
}
